import axios from "axios";
import Configurator from "../../config/Configurator";

/**
 * Builds a URL for the license key proposal endpoint with optional query parameters.
 * @param {boolean} expiryEnabled - Whether to include the expiry date parameter
 * @param {string} expiryValue - Expiry date as ISO string (e.g., "2026-07-20")
 * @param {boolean} usersLimitEnabled - Whether to include the user limit parameter
 * @param {number} usersLimitValue - Maximum number of users allowed
 * @param {object} userExpiryList - List of users with custom expiry date
 *
 * @returns {Promise<string>} The constructed URL with query parameters
 */
async function getUrl(expiryEnabled, expiryValue, usersLimitEnabled, usersLimitValue, usersExpiry) {
  let url = (await Configurator()).API_URL + "/license_key/proposal";
  const params = [];

  if (expiryEnabled) {
    params.push(`optionsExpiryEnabled=${encodeURIComponent(expiryEnabled)}`);
  }

  if (expiryValue) {
    params.push(`optionsExpiryValue=${encodeURIComponent(expiryValue)}`);
  }

  if (usersLimitEnabled) {
    params.push(`optionsUsersLimitEnabled=${encodeURIComponent(usersLimitEnabled)}`);
  }

  if (usersLimitValue) {
    params.push(`optionsUsersLimitValue=${encodeURIComponent(usersLimitValue)}`);
  }

  if (Object.keys(usersExpiry).length > 0) {
    params.push(`optionsUsersExpiry=${encodeURIComponent(JSON.stringify(usersExpiry))}`);
  }

  if (params.length > 0) {
    url += '?' + params.join('&');
  }

  return url;
}

/**
 * Builds a URL for the license key proposal endpoint with optional query parameters.
 * @param {boolean} expiryEnabled - Whether to include the expiry date parameter
 * @param {string} expiryValue - Expiry date as ISO string (e.g., "2026-07-20")
 * @param {boolean} usersLimitEnabled - Whether to include the user limit parameter
 * @param {number} usersLimitValue - Maximum number of users allowed
 * @param {object} userExpiryList - List of users with custom expiry date
 */
export async function fetchProposalEncrypted(expiryEnabled, expiryDate, limitEnabled, userLimit, usersExpiry) {
  try {
    const url = await getUrl(expiryEnabled, expiryDate, limitEnabled, userLimit, usersExpiry);

    const res = await axios.request({
      method: "get",
      url,
      headers: {
        Session: localStorage.getItem("apiKey"),
        "User-Id": localStorage.getItem("userID"),
        "Content-Type": "application/json",
      },
      validateStatus: () => true,
    });

    const ok = res.status >= 200 && res.status < 300

    if (!ok) {
      return {
        success: false,
        message: res.data?.status?.errDesc || "Failed to fetch proposal",
        raw: res.data
      };
    }
    return { success: true, value: res.data };
  } catch (err) {
    console.error("proposal error:", err);
    return { success: false, message: "Network error" };
  }
}
